import React, { useEffect, useState } from 'react';
import supabase from '../lib/supabase';
import ImageWithFallback from './ImageWithFallback';
import NewsModal from './NewsModal';
import MatchPhotoCarousel from './MatchPhotoCarousel';

const isPublicNews = (news) => {
  if (!news) return false;
  const status = news.status || 'published';
  if (status === 'published') return true;
  if (status === 'scheduled' && news.published_at) return new Date(news.published_at) <= new Date();
  return false;
};

const RelatedNews = ({ playerId = null, matchId = null, title = 'Σχετικά νέα' }) => {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!playerId && !matchId) return;
    let cancelled = false;
    const load = async () => {
      const table = playerId ? 'news_players_aox1234' : 'news_matches_aox1234';
      const foreignField = playerId ? 'player_id' : 'match_id';
      const foreignValue = playerId || matchId;
      const { data } = await supabase
        .from(table)
        .select('news:news_aox1234(id,title,excerpt,content,image,image_url,category,published_at,status,is_featured,team_categories)')
        .eq(foreignField, foreignValue);
      if (cancelled) return;
      const news = (data || [])
        .map((row) => row.news)
        .filter(isPublicNews)
        .sort((a, b) => new Date(b.published_at || 0) - new Date(a.published_at || 0))
        .slice(0, 6);
      setItems(news);
    };
    load();
    return () => { cancelled = true; };
  }, [playerId, matchId]);

  if (items.length === 0 && !matchId) return null;

  return (
    <>
      {matchId && <div className="mt-10"><MatchPhotoCarousel matchId={matchId} title="Φωτορεπορτάζ αγώνα" /></div>}
      {items.length > 0 && <section className="mt-10">
        <h2 className="text-2xl font-black text-gray-900">{title}</h2>
        <div className="mt-5 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {items.map((item) => (
            <button key={item.id} type="button" onClick={() => setSelected(item)} className="overflow-hidden rounded-2xl border bg-white text-left shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
              <div className="h-40 bg-gray-100"><ImageWithFallback src={item.image || item.image_url} alt={item.title} className="h-full w-full object-cover" /></div>
              <div className="p-4">
                <div className="text-xs font-bold uppercase tracking-wider text-primary-600">{item.category || 'Νέα'}</div>
                <h3 className="mt-2 line-clamp-2 font-black text-gray-900">{item.title}</h3>
                {item.excerpt && <p className="mt-2 line-clamp-2 text-sm text-gray-600">{item.excerpt}</p>}
              </div>
            </button>
          ))}
        </div>
      </section>}
      <NewsModal article={selected} isOpen={Boolean(selected)} onClose={() => setSelected(null)} />
    </>
  );
};

export default RelatedNews;
